export const State4 = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="12" height="12" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 3.5C1 2.12114 2.12114 1 3.5 1C4.87886 1 6 2.12114 6 3.5C6 3.75048 5.96236 3.99568 5.8923 4.22235L5.80327 4.51038L11 9.70711V11H9.20711L8.5 10.2929V9H7V7.5H5.5V6.29289L4.8438 5.6367L4.52856 5.77961C4.21755 5.9206 3.86786 6 3.5 6C2.12114 6 1 4.87886 1 3.5ZM2 3C2 2.44761 2.44761 2 3 2C3.55239 2 4 2.44761 4 3C4 3.55239 3.55239 4 3 4C2.44761 4 2 3.55239 2 3Z"
      fill="#AB6400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1C2.12114 1 1 2.12114 1 3.5C1 4.87886 2.12114 6 3.5 6C3.86786 6 4.21755 5.9206 4.52856 5.77961L4.8438 5.6367L5.5 6.29289V7.5H7V9H8.5V10.2929L9.20711 11H11V9.70711L5.80327 4.51038L5.8923 4.22235C5.96236 3.99568 6 3.75048 6 3.5C6 2.12114 4.87886 1 3.5 1ZM2 3C2 2.44761 2.44761 2 3 2C3.55239 2 4 2.44761 4 3C4 3.55239 3.55239 4 3 4C2.44761 4 2 3.55239 2 3Z"
      fill="#AB6400"
    />
    <path
      d="M1 3.5C1 2.12114 2.12114 1 3.5 1C4.87886 1 6 2.12114 6 3.5C6 3.75048 5.96236 3.99568 5.8923 4.22235L5.80327 4.51038L11 9.70711V11H9.20711L8.5 10.2929V9H7V7.5H5.5V6.29289L4.8438 5.6367L4.52856 5.77961C4.21755 5.9206 3.86786 6 3.5 6C2.12114 6 1 4.87886 1 3.5ZM3 2C2.44761 2 2 2.44761 2 3C2 3.55239 2.44761 4 3 4C3.55239 4 4 3.55239 4 3C4 2.44761 3.55239 2 3 2Z"
      stroke="#AB6400"
      strokeWidth="0.75"
      strokeLinejoin="bevel"
    />
  </svg>
);
